"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TLD_DEFAULT_LOCALE = exports.TLD_SUPPORTED_LOCALES = exports.LOCALE_DEFAULTS = exports.LOCALE_DEFAULTS_BY_LOCALE = exports.FR_CH_LOCALE_DEFAULT = exports.CH_LOCALE_DEFAULT = exports.DK_LOCALE_DEFAULT = exports.FI_LOCALE_DEFAULT = exports.EN_SG_LOCALE_DEFAULT = exports.EN_HK_LOCALE_DEFAULT = exports.NZ_LOCALE_DEFAULT = exports.AU_LOCALE_DEFAULT = exports.SE_LOCALE_DEFAULT = exports.PT_LOCALE_DEFAULT = exports.BE_LOCALE_DEFAULT = exports.NL_LOCALE_DEFAULT = exports.IT_LOCALE_DEFAULT = exports.FR_BE_LOCALE_DEFAULT = exports.FR_LOCALE_DEFAULT = exports.ES_LOCALE_DEFAULT = exports.AT_LOCALE_DEFAULT = exports.DE_LOCALE_DEFAULT = exports.IE_LOCALE_DEFAULT = exports.UK_LOCALE_DEFAULT = exports.PE_LOCALE_DEFAULT = exports.CO_LOCALE_DEFAULT = exports.MX_LOCALE_DEFAULT = exports.CL_LOCALE_DEFAULT = exports.BR_LOCALE_DEFAULT = exports.AR_LOCALE_DEFAULT = exports.FR_CA_LOCALE_DEFAULT = exports.CA_LOCALE_DEFAULT = exports.ES_US_LOCALE_DEFAULT = exports.US_LOCALE_DEFAULT = exports.SUPPORTED_TLDS = exports.PARENT_LANGUAGES = exports.SUPPORTED_LOCALES = exports.DEFAULT_LOCALE = exports.DEFAULT_TLD = exports.EBLANG_PARAM = exports.LANG_PARAM = void 0;
exports.LANG_PARAM = "lang";
exports.EBLANG_PARAM = "eblang";
exports.DEFAULT_TLD = "com";
exports.DEFAULT_LOCALE = "en_US";
/*
 Parent-child locale mapping. We have several countries that will use parent locale as their locale.
 examples:
 es_AR Argentina does not have a parent Language, es_AR is a parent language
 en_CA Canada Locale is a child locale from en_US, Canada will use the en_US locale parent language
*/
exports.SUPPORTED_LOCALES = {
    de_DE: ["de_AT", "de_CH"],
    en_AU: ["en_NZ"],
    en_GB: ["en_IE", "en_SG", "en_HK", "en_DK", "en_FI"],
    en_US: ["en_CA"],
    es_AR: undefined,
    es_ES: ["es_CL", "es_CO", "es_PE"],
    es_MX: undefined,
    es_US: undefined,
    fr_FR: ["fr_BE", "fr_CH"],
    fr_CA: undefined,
    it_IT: undefined,
    nl_NL: ["nl_BE"],
    pt_BR: undefined,
    pt_PT: undefined,
    sv: undefined,
};
exports.PARENT_LANGUAGES = Object.keys(exports.SUPPORTED_LOCALES);
exports.SUPPORTED_TLDS = Object.freeze({
    at: "de_AT",
    be: "nl_BE",
    ca: "en_CA",
    ch: "de_CH",
    cl: "es_CL",
    co: "es_CO",
    "co.nz": "en_NZ",
    "co.uk": "en_GB",
    com: "en_US",
    "com.ar": "es_AR",
    "com.au": "en_AU",
    "com.br": "pt_BR",
    "com.mx": "es_MX",
    "com.pe": "es_PE",
    de: "de_DE",
    dk: "en_DK",
    es: "es_ES",
    fi: "en_FI",
    fr: "fr_FR",
    hk: "en_HK",
    ie: "en_IE",
    in: "en_IN",
    it: "it_IT",
    nl: "nl_NL",
    no: "nn_NO",
    pt: "pt_PT",
    se: "sv",
    sg: "en_SG",
});
const BaseLocaleDefault = {
    locale: null,
    tld: null,
    country_code: "US",
    default_timezone: "America/Los_Angeles",
    locale_name: "Global",
    uses_language_subdirectory: false,
    localized_language_name: "English (US)",
    default_language: "en-us",
    get help_center_language() {
        return this.default_language;
    },
    press_blog_url: "/blog/press/",
    country_place_id: "85633793",
    is_default_for_tld: true,
};
exports.US_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "en_US",
    tld: ".com",
    country_code: "US",
    default_timezone: "America/Los_Angeles",
    locale_name: "United States",
    country_place_id: "85633793",
    is_default_for_tld: true,
};
// TODO under a FF
exports.ES_US_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "es_US",
    tld: ".com",
    locale_name: "Estados Unidos (ES)",
    localized_language_name: "Español (EUA)",
    uses_language_subdirectory: true,
    default_language: "es-us",
    help_center_language: "es-us",
    country_place_id: "85633793",
    is_default_for_tld: false,
};
exports.CA_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "en_CA",
    tld: ".ca",
    country_code: "CA",
    default_timezone: "America/Toronto",
    locale_name: "Canada (EN)",
    localized_language_name: "English (CS)",
    default_language: "en-ca",
    help_center_language: "en-ca",
    country_place_id: "85633041",
};
exports.FR_CA_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "fr_CA",
    tld: ".ca",
    country_code: "CA",
    default_timezone: "America/Montreal",
    locale_name: "Canada (FR)",
    localized_language_name: "Français (CS)",
    uses_language_subdirectory: true,
    default_language: "fr-ca",
    help_center_language: "fr-ca",
    country_place_id: "85633041",
    is_default_for_tld: false,
};
exports.AR_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "es_AR",
    tld: ".com.ar",
    country_code: "AR",
    default_timezone: "America/Argentina/Buenos_Aires",
    locale_name: "Argentina",
    localized_language_name: "Español (AR)",
    default_language: "es-ar",
    help_center_language: "es-ar",
    country_place_id: "85632505",
};
exports.BR_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "pt_BR",
    tld: ".com.br",
    country_code: "BR",
    default_timezone: "America/Sao_Paulo",
    locale_name: "Brasil",
    localized_language_name: "Português (BR)",
    default_language: "pt-br",
    help_center_language: "pt-br",
    country_place_id: "85633009",
};
exports.CL_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "es_CL",
    tld: ".cl",
    country_code: "CL",
    default_timezone: "America/Santiago",
    locale_name: "Chile",
    localized_language_name: "Español",
    default_language: "es-es",
    help_center_language: "es-cl",
    country_place_id: "85633057",
};
exports.MX_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "es_MX",
    tld: ".com.mx",
    country_code: "MX",
    default_timezone: "America/Mexico_City",
    locale_name: "México",
    localized_language_name: "Español (MX)",
    default_language: "es-mx",
    help_center_language: "es-mx",
    country_place_id: "85633293",
};
exports.CO_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "es_CO",
    tld: ".co",
    country_code: "CO",
    default_timezone: "America/Bogota",
    locale_name: "Colombia",
    localized_language_name: "Español (ES)",
    default_language: "es-es",
    help_center_language: "es-co",
    country_place_id: "85632519",
};
exports.PE_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "es_PE",
    tld: ".com.pe",
    country_code: "PE",
    default_timezone: "America/Lima",
    locale_name: "Perú",
    localized_language_name: "Español (ES)",
    default_language: "es-es",
    help_center_language: "es-pe",
    country_place_id: "85632521",
};
exports.UK_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "en_GB",
    tld: ".co.uk",
    country_code: "UK",
    default_timezone: "Europe/London",
    locale_name: "United Kingdom",
    localized_language_name: "English (UK)",
    default_language: "en-gb",
    help_center_language: "en-gb",
    country_place_id: "85633159",
};
exports.IE_LOCALE_DEFAULT = {
    ...exports.UK_LOCALE_DEFAULT,
    locale: "en_IE",
    tld: ".ie",
    country_code: "IE",
    default_timezone: "Europe/Dublin",
    locale_name: "Ireland",
    help_center_language: "en-ie",
    country_place_id: "85633241",
};
exports.DE_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "de_DE",
    tld: ".de",
    country_code: "DE",
    default_timezone: "Europe/Berlin",
    locale_name: "Deutschland",
    localized_language_name: "Deutsch",
    default_language: "de-de",
    help_center_language: "de",
    country_place_id: "85633111",
};
exports.AT_LOCALE_DEFAULT = {
    ...exports.DE_LOCALE_DEFAULT,
    locale: "de_AT",
    tld: ".at",
    country_code: "AT",
    default_timezone: "Europe/Vienna",
    locale_name: "Österreich",
    help_center_language: "de",
    country_place_id: "85633111",
};
exports.ES_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "es_ES",
    tld: ".es",
    country_code: "ES",
    default_timezone: "Europe/Madrid",
    locale_name: "España",
    localized_language_name: "Español (ES)",
    default_language: "es-es",
    help_center_language: "es",
    country_place_id: "85633129",
};
exports.FR_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "fr_FR",
    tld: ".fr",
    country_code: "FR",
    default_timezone: "Europe/Paris",
    locale_name: "France",
    localized_language_name: "Français",
    default_language: "fr-fr",
    help_center_language: "fr",
    country_place_id: "85633147",
};
exports.FR_BE_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "fr_BE",
    tld: ".be",
    country_code: "BE",
    default_timezone: "Europe/Brussels",
    locale_name: "Belgique",
    localized_language_name: "Français (BE)",
    uses_language_subdirectory: true,
    help_center_language: "fr",
    country_place_id: "85632997",
    is_default_for_tld: false,
};
exports.IT_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "it_IT",
    tld: ".it",
    country_code: "IT",
    default_timezone: "Europe/Rome",
    locale_name: "Italia",
    localized_language_name: "Italiano",
    default_language: "it-it",
    help_center_language: "it",
    country_place_id: "85633253",
};
exports.NL_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "nl_NL",
    tld: ".nl",
    country_code: "NL",
    default_timezone: "Europe/Amsterdam",
    locale_name: "Nederland",
    localized_language_name: "Nederlands",
    default_language: "nl-nl",
    help_center_language: "nl-nl",
    country_place_id: "85633337",
};
exports.BE_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "nl_BE",
    tld: ".be",
    country_code: "BE",
    default_timezone: "Europe/Brussels",
    locale_name: "België",
    localized_language_name: "Belge",
    help_center_language: "nl-nl",
    country_place_id: "85632997",
};
exports.PT_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "pt_PT",
    tld: ".pt",
    country_code: "PT",
    default_timezone: "Europe/Lisbon",
    locale_name: "Portugal",
    localized_language_name: "Português",
    default_language: "pt-pt",
    help_center_language: "pt-pt",
    country_place_id: "85633735",
};
exports.SE_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "sv",
    tld: ".se",
    country_code: "SE",
    default_timezone: "Europe/Stockholm",
    locale_name: "Sverige",
    localized_language_name: "Svenska",
    default_language: "sv",
    help_center_language: "sv",
    country_place_id: "85633789",
};
exports.AU_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "en_AU",
    tld: ".com.au",
    country_code: "AU",
    default_timezone: "Australia/Sydney",
    locale_name: "Australia",
    localized_language_name: "English (Australia/New Zealand)",
    default_language: "en-au",
    help_center_language: "en-au",
    country_place_id: "85632793",
};
exports.NZ_LOCALE_DEFAULT = {
    ...exports.AU_LOCALE_DEFAULT,
    locale: "en_NZ",
    tld: ".co.nz",
    country_code: "NZ",
    default_timezone: "Pacific/Auckland",
    locale_name: "New Zealand",
    default_language: "en-au",
    help_center_language: "en-nz",
    country_place_id: "85633345",
};
exports.EN_HK_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "en_HK",
    tld: ".hk",
    country_code: "HK",
    default_timezone: "Asia/Hong_Kong",
    locale_name: "Hong Kong",
    localized_language_name: "English (HK)",
    default_language: "en-gb",
    help_center_language: "en-hk",
    country_place_id: "85632483",
};
exports.EN_SG_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "en_SG",
    tld: ".sg",
    country_code: "SG",
    default_timezone: "Asia/Singapore",
    locale_name: "Singapore",
    localized_language_name: "English (SG)",
    default_language: "en-gb",
    help_center_language: "en-sg",
    country_place_id: "85632605",
};
exports.FI_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "en_FI",
    tld: ".fi",
    country_code: "FI",
    default_timezone: "Europe/Helsinki",
    locale_name: "Finland",
    localized_language_name: "English (FI)",
    default_language: "en-fi",
    help_center_language: "fi",
    country_place_id: "85633143",
};
exports.DK_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "en_DK",
    tld: ".dk",
    country_code: "DK",
    default_timezone: "Europe/Copenhagen",
    locale_name: "Denmark",
    localized_language_name: "English (DK)",
    default_language: "en-dk",
    help_center_language: "da",
    country_place_id: "85633121",
};
exports.CH_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "de_CH",
    tld: ".ch",
    country_code: "CH",
    default_timezone: "Europe/Zurich",
    locale_name: "Schweiz",
    localized_language_name: "Deutsch (CH)",
    default_language: "de-de",
    help_center_language: "de-ch",
    country_place_id: "85633051",
};
exports.FR_CH_LOCALE_DEFAULT = {
    ...BaseLocaleDefault,
    locale: "fr_CH",
    tld: ".ch",
    country_code: "CH",
    default_timezone: "Europe/Zurich",
    locale_name: "Suisse",
    localized_language_name: "Français (CH)",
    uses_language_subdirectory: true,
    default_language: "fr-fr",
    help_center_language: "fr-ch",
    country_place_id: "85633051",
    is_default_for_tld: false,
};
exports.LOCALE_DEFAULTS_BY_LOCALE = {
    en_US: exports.US_LOCALE_DEFAULT,
    // es_US: ES_US_LOCALE_DEFAULT, // TODO under a FF
    en_CA: exports.CA_LOCALE_DEFAULT,
    fr_CA: exports.FR_CA_LOCALE_DEFAULT,
    es_AR: exports.AR_LOCALE_DEFAULT,
    pt_BR: exports.BR_LOCALE_DEFAULT,
    es_CL: exports.CL_LOCALE_DEFAULT,
    es_MX: exports.MX_LOCALE_DEFAULT,
    es_CO: exports.CO_LOCALE_DEFAULT,
    es_PE: exports.PE_LOCALE_DEFAULT,
    en_GB: exports.UK_LOCALE_DEFAULT,
    en_IE: exports.IE_LOCALE_DEFAULT,
    de_DE: exports.DE_LOCALE_DEFAULT,
    de_AT: exports.AT_LOCALE_DEFAULT,
    es_ES: exports.ES_LOCALE_DEFAULT,
    fr_FR: exports.FR_LOCALE_DEFAULT,
    fr_BE: exports.FR_BE_LOCALE_DEFAULT,
    it_IT: exports.IT_LOCALE_DEFAULT,
    nl_NL: exports.NL_LOCALE_DEFAULT,
    nl_BE: exports.BE_LOCALE_DEFAULT,
    pt_PT: exports.PT_LOCALE_DEFAULT,
    sv: exports.SE_LOCALE_DEFAULT,
    en_AU: exports.AU_LOCALE_DEFAULT,
    en_NZ: exports.NZ_LOCALE_DEFAULT,
    en_HK: exports.EN_HK_LOCALE_DEFAULT,
    en_SG: exports.EN_SG_LOCALE_DEFAULT,
    en_FI: exports.FI_LOCALE_DEFAULT,
    en_DK: exports.DK_LOCALE_DEFAULT,
    de_CH: exports.CH_LOCALE_DEFAULT,
    fr_CH: exports.FR_CH_LOCALE_DEFAULT,
};
exports.LOCALE_DEFAULTS = Object.values(exports.LOCALE_DEFAULTS_BY_LOCALE);
/**
 * Helper function to get the parent locale for a given locale.
 * Uses the SUPPORTED_LOCALES parent-child mapping.
 */
const getParentLocale = (locale) => {
    const childLocales = exports.SUPPORTED_LOCALES[locale];
    if (childLocales !== undefined) {
        return locale;
    }
    for (const [parent, children] of Object.entries(exports.SUPPORTED_LOCALES)) {
        if (children && children.includes(locale)) {
            return parent;
        }
    }
    return locale;
};
/**
 * Helper function to build a map of TLD to supported locale codes (using parent locales).
 * Computed once and cached.
 */
const buildTldSupportedLocales = () => {
    const map = {};
    for (const localeDefault of exports.LOCALE_DEFAULTS) {
        const tld = localeDefault.tld;
        const parentLocale = getParentLocale(localeDefault.locale);
        if (!map[tld]) {
            map[tld] = [];
        }
        if (!map[tld].includes(parentLocale)) {
            map[tld].push(parentLocale);
        }
    }
    return map;
};
/**
 * Helper function to build a map of TLD to its default locale code (using parent locale).
 * Computed once and cached.
 */
const buildTldDefaultLocale = () => {
    const map = {};
    for (const localeDefault of exports.LOCALE_DEFAULTS) {
        if (localeDefault.is_default_for_tld) {
            const parentLocale = getParentLocale(localeDefault.locale);
            map[localeDefault.tld] = parentLocale;
        }
    }
    return map;
};
/**
 * Maps each TLD to its array of supported locale codes.
 * TLDs with multiple locales: .ca, .com, .be, .ch
 */
exports.TLD_SUPPORTED_LOCALES = buildTldSupportedLocales();
/**
 * Maps each TLD to its default locale code.
 */
exports.TLD_DEFAULT_LOCALE = buildTldDefaultLocale();
//# sourceMappingURL=constants.js.map